import { Typography } from '@mui/material';
import React from 'react';
import { OTP_VERIFICATION } from '../../shared/Strings';

export const TimerComponent = ({ resendTime }) => {
  return (
    <Typography
      sx={{
        mt: '11px',
        color: '#666666',
      }}>
      {OTP_VERIFICATION.RESEND_TIMER}:{resendTime}
    </Typography>
  );
};
